exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.currenciesGroup .v-list-group__header {\n    min-height: 32px !important;\n}\n\n", ""]);
